import { useSearchParams } from "react-router-dom";
import { SupervisionCard } from "@/shared/ui";
import { SupervisionCardsListProps } from "../../types";
import "./supervision-cards-list.scss";

export const SupervisionCardsList = ({
  packages,
  onAddToPackage,
  onLinkMessage,
}: SupervisionCardsListProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const openNotificationView = (id: string) => {
    const params = new URLSearchParams(searchParams);
    params.set("notificationId", id);
    setSearchParams(params);
  };

  return (
    <div className="supervision-cards-list">
      {packages &&
        packages.map((packageItem) => (
          <SupervisionCard
            key={packageItem.id}
            title={packageItem.title}
            textNumber={packageItem.textNumber}
            chippers={packageItem.chippers}
            table={packageItem.table}
            variant={packageItem.variant || "default"}
            onAddToPackage={() => onAddToPackage?.(packageItem.id)}
            showSignButton={packageItem.tab === "processing"}
            onLinkMessage={() => onLinkMessage?.(packageItem.id)}
            onTitleClick={() => openNotificationView(packageItem.id)}
          />
        ))}
    </div>
  );
};

